<template>
  <el-dialog class="user-dialog" v-bind="$attrs" v-on="$listeners" @close="close">
    <div class="el-dialog-body-child">
      <el-form ref="queryForm" :model="queryParams" label-width="80px" :inline="true" class="search-form clearfix">
        <el-form-item class="search-field inventory-entry fl" :label="type === 'pay' ? '付款方式' : '收款方式'" prop="payWay">
          <el-select-dict dictType="PAY_WAY" clearable :placeholder="type === 'pay' ? '请选择付款方式' : '请选择收款方式'"
            v-model="queryParams.payWay" @dictChange="handleQuery"></el-select-dict>
        </el-form-item>
        <el-form-item class="search-field inventory-entry fl" :label="type === 'pay' ? '付款时间' : '收款时间'"
          prop="beginTime">
          <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <div class="fr">
          <el-button plain @click="resetQuery">重 置</el-button>
          <el-button type="primary" @click="handleQuery">查 询</el-button>
        </div>
      </el-form>
      <div class="table-wrap">
        <div class="table-box">
          <auto-height-table instanceHeight="338" :class="{ 'empty': list.length === 0 }" empty-text=" "
            v-loading="loading" :data="list">
            <el-table-column label="付款人" prop="payCustomer.customerName" align="center" min-width="120px" />
            <el-table-column label="收款人" prop="receivedCustomer.customerName" align="center" min-width="120px" />
            <el-table-column :label="type === 'pay' ? '当前未付款金额' : '当前未收款金额'" prop="outstandingAmount" align="center"
              min-width="120px" />
            <el-table-column :label="type === 'pay' ? '付款金额' : '收款金额'" prop="payAmount" align="center"
              min-width="120px" />
            <el-table-column-dict :label="type === 'pay' ? '付款方式' : '收款方式'" dictType="PAY_WAY" prop="payWay"
              align="center" min-width="120px" />
            <el-table-column :label="type === 'pay' ? '付款时间' : '收款时间'" prop="payTime" align="center" min-width="136px" />
            <el-table-column :label="type === 'pay' ? '付款截图' : '收款截图'" align="center" min-width="120px">
              <template slot-scope="scope">
                <img @click.stop="mixinHandlePreview(scope.row.payScreenshotList)" :src="mixinGetImg(scope.row.payScreenshotList[0])" width="40px"
                  height="40px" :alt="type === 'pay' ? '付款截图' : '收款截图'" />
              </template>
            </el-table-column>
            <el-table-column-dict defaultVal="--" label="备注" prop="remark" align="center" :show-overflow-tooltip="true" width="168px" />
          </auto-height-table>
          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize" @pagination="getList" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { payRecordApi } from "@/api"
export default {
  props: {
    type: {
      type: String
    }
  },
  data() {
    return {
      dateRange: [],
      //搜索条件参数
      queryParams: {
        beginTime: "",
        endTime: "",
        billId: "",
        payWay: "",
        pageNum: 1,
        pageSize: 10
      },
      loading: false,
      list: [],
      total: 0
    }
  },
  methods: {
    handleSelect(row) {
      this.$emit("handleSelect", row)
    },
    close() {
      this.resetQuery()
      this.$emit("closeRecord")
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询列表 */
    getList(billId) {
      if (billId) {
        this.queryParams.billId = billId
      }
      this.loading = true
      payRecordApi
        .getList(this.mixinAddDateRange(this.queryParams, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped></style>
